/** Fixed nav height — keep in sync with `.nav__inner` in styles.css */
export const NAV_OFFSET = 76;

/**
 * Scroll to a homepage section hash, accounting for the fixed nav.
 * Pass '' or '#top' to go to the top of the page.
 */
export function scrollToHashOrTop(hash) {
  if (!hash || hash === '#top') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  const id = hash.replace(/^#/, '');
  const el = document.getElementById(id);
  if (!el) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  const top = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}
